import {
  SignatureState,
  signRegistry,
  signFinalRegistry,
} from '@builddocs/filestore-api'

type SendSignedRegistryArgs = {
  documentId: string
  employmentId: string
  signedHash: string
  actRegistryBase64signature: string
  keyIssuer: string
  imprint: string
  signerName: string
  facePhoto: string
  keySerialNumber: string
  type: 'default' | 'final'
  withPoa?: boolean
  poaId?: string | null
  poaDateStart?: string | null
  poaDateEnd?: string | null
}

export const sendSignedRegistry = async ({
  documentId,
  employmentId,
  signedHash,
  actRegistryBase64signature,
  keyIssuer,
  imprint,
  signerName,
  facePhoto,
  keySerialNumber,
  type,
  poaId,
  withPoa,
  poaDateStart,
  poaDateEnd,
}: SendSignedRegistryArgs) => {
  const args = {
    documentId,
    employmentId,
    signatureState: SignatureState.SIGNED as SignatureState.SIGNED,
    base64signature: signedHash,
    actRegistryBase64signature,
    keyIssuer,
    imprint,
    name: signerName,
    faceId: {
      faceImage: facePhoto,
      keySerialNumber,
    },
    poaId,
    withPoa,
    poaDateStart,
    poaDateEnd,
  }

  return type === 'default'
    ? await signRegistry(args)
    : await signFinalRegistry(args)
}
